import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { cn } from "@/lib/utils";

export const DEFAULT_SORT = { key: "date", dir: "desc" };

const RISQUE_ORDER = { "Élevé": 3, Vigilance: 2, Faible: 1, "Non évalué": 0 };
const STATUT_ORDER = { en_cours: 0, en_attente_documents: 1, clos: 2 };

const SORTERS = {
    date: (d) => new Date(d.created_at).getTime(),
    entreprise: (d) => `${d.nom_mission || ""} ${d.entreprises?.nom_entreprise || ""}`.trim().toLocaleLowerCase("fr"),
    statut: (d) => STATUT_ORDER[d.statut_dossier] ?? 9,
    risque: (d) => RISQUE_ORDER[d.niveau_risque] ?? 0,
};

export function applySort(dossiers, sort) {
    const get = SORTERS[sort.key] || SORTERS.date;
    const m = sort.dir === "asc" ? 1 : -1;
    return [...dossiers].sort((a, b) => {
        const va = get(a), vb = get(b);
        if (va < vb) return -1 * m;
        if (va > vb) return 1 * m;
        return 0;
    });
}

const COLS = [
    { key: "entreprise", label: "Mission / Entreprise", className: "flex-1 text-left" },
    { key: "risque", label: "Risque", className: "w-[130px] text-left" },
    { key: "statut", label: "Statut", className: "w-[190px] text-left" },
    { key: "date", label: "Créé le", className: "w-24 text-right" },
];

export default function DossierSortHeader({ sort, onChange }) {
    function toggle(key) {
        if (sort.key === key) onChange({ key, dir: sort.dir === "asc" ? "desc" : "asc" });
        else onChange({ key, dir: key === "date" ? "desc" : "asc" });
    }
    return (
        <div data-testid="dossier-sort-header" className="px-5 py-2 flex items-center gap-5 border-b border-slate-200 bg-slate-50 rounded-t-xl">
            {COLS.map((c) => {
                const active = sort.key === c.key;
                const Icon = !active ? ArrowUpDown : sort.dir === "asc" ? ArrowUp : ArrowDown;
                return (
                    <button
                        key={c.key}
                        type="button"
                        data-testid={`sort-${c.key}`}
                        aria-sort={active ? (sort.dir === "asc" ? "ascending" : "descending") : "none"}
                        onClick={() => toggle(c.key)}
                        className={cn(
                            "inline-flex items-center gap-1 text-sm font-semibold transition-colors",
                            c.className,
                            active ? "text-indigo-700" : "text-slate-500 hover:text-slate-800"
                        )}
                    >
                        {c.key === "date" && <Icon className="h-3 w-3" />}
                        {c.label}
                        {c.key !== "date" && <Icon className="h-3 w-3" />}
                    </button>
                );
            })}
            <span className="w-4" />
        </div>
    );
}
